import { api, formatApiError } from "../../../lib/api";

export const FR = "/admin/fee-rec";
export const inr = (v) => (v == null || v === "" ? "—" : `₹${Number(v).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`);
export const errMsg = (e) => formatApiError(e?.response?.data?.detail) || "Something went wrong";
export const TIER_CLS = {
    1: "bg-indigo-100 text-indigo-800 border-indigo-200",
    2: "bg-sky-100 text-sky-800 border-sky-200",
    3: "bg-emerald-100 text-emerald-800 border-emerald-200",
    4: "bg-amber-100 text-amber-800 border-amber-200",
};
export const FEAS = {
    feasible: { cls: "bg-emerald-50 border-emerald-200 text-emerald-900", tag: "A" },
    below_min: { cls: "bg-rose-50 border-rose-200 text-rose-900", tag: "B" },
    above_max: { cls: "bg-amber-50 border-amber-200 text-amber-900", tag: "C" },
};
export const APPROVAL = {
    not_required: { label: "Within range", cls: "bg-emerald-100 text-emerald-800" },
    pending: { label: "Approval pending", cls: "bg-amber-100 text-amber-800" },
    approved: { label: "Approved", cls: "bg-blue-100 text-blue-800" },
    rejected: { label: "Rejected", cls: "bg-rose-100 text-rose-800" },
};
export const CONVERSION = { open: "Open", converted: "Converted", lost: "Lost" };
export const LOST_REASONS = { budget: "Budget too low", timing: "Timing", no_response: "No response", chose_other: "Chose another option", other: "Other" };
export const WEEKDAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
export const MONTHLY_RULE_LABEL = { actual: "Real class days in the month", average: "Yearly average (× 52 ÷ 12)", flat4: "Flat 4 weeks" };

export const quoteUrl = (token) => `${window.location.origin}/fee-quote/${token}`;
export const quoteMessage = (q, token) => [
    "*Anand Tutorials | Fee Quotation*", "",
    `Dear ${q.parent_name || "Parent"},`, "",
    "Greetings from Anand Tutorials! Please find the fee quotation for 1:1 Live Online Classes:", "",
    `• Course: ${[q.category, q.board, q.grade, q.subject].filter(Boolean).join(" · ")}`,
    `• Session: ${q.duration} min · ${q.sessions_per_week} per week (${q.monthly_sessions} sessions this month)`,
    q.fee_basis === "monthly" ? `• Monthly fee: ${inr(q.quoted_fee)}` : `• Fee per session: ${inr(q.quoted_fee)}`,
    q.fee_basis === "monthly" ? null : `• Estimated monthly fee: ${inr(q.monthly_estimate)}`,
    q.subjects_note ? `• ${q.subjects_note}` : null, "",
    `View / download: ${quoteUrl(token)}`, "",
    "Best regards,", "Anand Tutorials",
].filter((x) => x !== null).join("\n");

export const frApi = {
    get: (p, params) => api.get(`${FR}${p}`, { params }).then((r) => r.data),
    post: (p, body) => api.post(`${FR}${p}`, body).then((r) => r.data),
    put: (p, body) => api.put(`${FR}${p}`, body).then((r) => r.data),
    patch: (p, body) => api.patch(`${FR}${p}`, body).then((r) => r.data),
    del: (p) => api.delete(`${FR}${p}`).then((r) => r.data),
};

export const numOrNull = (v) => (v === "" || v == null ? null : Number(v));
export const toPayload = (f) => ({
    ...f, category_id: f.category_id || null, duration: Number(f.duration) || 60, sessions_per_week: Number(f.sessions_per_week) || 1,
    monthly_sessions_override: numOrNull(f.monthly_sessions_override), budget_amount: numOrNull(f.budget_amount),
    proposed_fee: numOrNull(f.proposed_fee), final_fee: numOrNull(f.final_fee),
});
export const fieldCls = "w-full h-11 px-3 text-base sm:text-sm bg-white border border-slate-200 rounded-lg outline-none focus:border-[#1E3A8A] focus:ring-1 focus:ring-[#1E3A8A]";
export const labelCls = "block text-[11px] uppercase tracking-wider font-bold text-slate-500 mb-1";
export const cardCls = "bg-white border border-slate-200 rounded-2xl p-4 sm:p-5";
export const btnPrimary = "inline-flex items-center justify-center gap-2 h-11 px-4 rounded-lg bg-[#1E3A8A] text-white text-sm font-semibold hover:bg-[#1E40AF] disabled:opacity-50 transition-colors";
export const btnGhost = "inline-flex items-center justify-center gap-2 h-11 px-4 rounded-lg border border-slate-200 bg-white text-slate-700 text-sm font-semibold hover:bg-slate-50 disabled:opacity-50 transition-colors";
